import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";

export default function GuaranteFeature({
  control,
  register,
  errors,
  resetField,
  isStaticPlanType,
  guarentedFeature
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "guarentedFeature"
  });

  useEffect(() => {
    resetField('guarentedFeature')
    guarentedFeature.forEach(element => {
      append(element)  
    });
  }, [])

  return (
    <form>
      <div className="planProfileCard">
        <h5>You are guaranteed to receive:</h5>
        <div className="form-group form-margin">
          <div className="row">

            {fields.map((field, index) => (
               <div key={field.id} className="col-lg-12 fieldPadding">
               <p className="input-text heading">Feature {index + 1}</p>
               {fields.length > 2 && (
                 <div
                   onClick={() => remove(index)}
                   className="removeBtn"
                 >
                   <i className="fa fa-times-circle" aria-hidden="true"></i>
                 </div>
               )}
               <input
                 autoComplete="off"
                 type="text"
                 className="form-control"
                 placeholder="Type feature here"
                 {...register(`guarentedFeature.${index}`, {
                  required: !isStaticPlanType,
                 })}
               />
               {errors[`guarentedFeature`]?.[index] && errors[`guarentedFeature`]?.[index]?.type === "required" && (
                   <span className="errorMessage">
                     Feature {index + 1} is required
                   </span>
                 )}
             </div>
            ))}

            
            <div className="col-lg-4">
              <div
                onClick={() => append('')}
                className="addMoreFeature"
              >
                <img src="assets/img/plusBtn.svg" alt="" />
                Add another feature
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
